import { ControlConfig } from '../controlConfig';
import AddControlNumeric from './AddControlNumeric';
import ControlNumericEngine from './ControlNumericEngine';
import ControlNumericEntry from './ControlNumericEntry';
import ControlNumericPlaceholder from './ControlNumericPlaceholder';
import getLatestSchema from './schema';
import getDefaultValue from './getDefaultValue';
import getYupSchemaForNumericEngine from './getYupSchemaForNumericEngine';
import getYupSchemaForNumericEntry from './getYupSchemaForNumericEntry';
import translator from './translator';

export default {
  getDefaultValue,
  getLatestSchema,
  Engine: ControlNumericEngine,
  Entry: ControlNumericEntry,
  Add: AddControlNumeric,
  yupSchemaEngine: getYupSchemaForNumericEngine,
  yupSchemaEntry: getYupSchemaForNumericEntry,
  translator,
  Placeholder: ControlNumericPlaceholder,
  previewCardHeight: '120px'
} as ControlConfig;
